import styled from '@emotion/styled';

import { COLORS3, FONT, SPACING } from '@zola/zola-ui/src/styles/emotion';
import { COLORS_TEXT } from '@zola/zola-ui/src/styles/emotion/colors';

import { ButtonV3 } from '@zola/zola-ui/src/components/ButtonV3';
import RadioFieldV2 from '@zola/zola-ui/src/components/Form/RadioFieldV2/RadioField/RadioFieldV2';
import DropdownV3 from '@zola/zola-ui/src/components/Form/dropdownV3';
import { Input } from '@zola/zola-ui/src/components/Form/inputV3/InputFieldV3/InputFieldV3.styles';
import { StyledLabel } from '@zola/zola-ui/src/components/Form/RadioFieldV2/RadioField/RadioFieldV2.styles';
import { ListBoxContainer } from '@zola/zola-ui/src/components/Form/common/DropdownListBox/DropdownListBox.styles';

export const Grid = styled.div<{ gap?: keyof typeof SPACING }>`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: ${({ gap = 'XS' }) => SPACING[gap]};
  margin-top: ${SPACING.LG};
`;

export const StyledP = styled.p`
  margin: ${SPACING.S16} 0 0;
  color: ${COLORS3.BLACK_100};
`;

export const NoteField = styled.div`
  margin-bottom: ${SPACING.LG};
`;

export const NotesLabel = styled.label`
  ${FONT.textSizeCompact(FONT.SIZE.SMALL)}
  font-weight: ${FONT.WEIGHT.REGULAR};
  font-family: ${FONT.FAMILY.SANS_SERIF};
  text-transform: none;
  letter-spacing: normal;
  margin-top: ${SPACING.S16};
`;

export const Optional = styled.span`
  color: ${COLORS3.BLACK_050};
`;

export const AmountField = styled.div`
  ${Input} {
    text-align: right;
  }
`;

export const SetUpAReminder = styled.div`
  padding-top: ${SPACING.LG};
  border-top: 1px solid ${COLORS3.BLACK_015};
`;

export const ReminderTitle = styled.h3`
  margin: 0 0 ${SPACING.XS};
  ${FONT.textSizeCompact(FONT.SIZE.LARGE)}
`;

export const ReminderSubtitle = styled.p`
  margin: 0 0 ${SPACING.S24};
  color: ${COLORS3.BLACK_100};
`;

export const ReminderRadios = styled.div`
  margin-bottom: ${SPACING.S24};
  ${StyledLabel} {
    color: ${COLORS_TEXT.BODY};
    font-weight: ${FONT.WEIGHT.SEMI_BOLD};
    text-transform: none;
    letter-spacing: normal;
    ${FONT.textSizeCompact(FONT.SIZE.SMALL)};
  }
`;

export const StyledRadio = styled(RadioFieldV2)`
  &:first-of-type {
    margin-bottom: ${SPACING.S16};
  }
`;

export const ReminderFields = styled.div`
  margin-bottom: ${SPACING.S16};

  & > * {
    margin-top: ${SPACING.XS};
  }
`;

export const StyledDropdown = styled(DropdownV3)`
  ${ListBoxContainer} {
    max-height: 175px;
  }
`;

export const StyledDeleteButton = styled(ButtonV3)`
  margin-top: ${SPACING.LG};
`;
